import GetProductTagsQuery from './ProductTags';

export default GetProductTagsQuery;


// WEBPACK FOOTER //
// ./src/components/Query/ProductTags/index.ts